import { useParams, Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.categoryId === slug);

  if (!category) {
    return (
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-20 text-center">
        <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">分类未找到</h1>
        <Link to="/" className="text-primary-600 hover:text-primary-700">返回首页</Link>
      </div>
    );
  }

  const breadcrumbData = [
    { name: '首页', item: 'https://17c.com' },
    { name: category.name, item: `https://17c.com/category/${category.slug}` },
  ];

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${category.name} — 17c.com GitHub 资源汇总`,
          description: category.description,
          url: `https://17c.com/category/${category.slug}`,
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbData.map((item, i) => ({
              '@type': 'ListItem',
              position: i + 1,
              name: item.name,
              item: item.item,
            })),
          },
        }}
      />
      <SchemaOrg type="BreadcrumbList" data={{ items: breadcrumbData }} />

      <div className="bg-background-100 border-b border-background-200/70">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />
          <div className="mt-6">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className={`${category.icon} text-xl`}></i>
              </div>
              <div>
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  {category.name}
                </h1>
                <p className="text-sm text-foreground-500 mt-1">
                  {category.articleCount} 篇文章
                </p>
              </div>
            </div>
            <p className="text-foreground-600 text-sm max-w-2xl">{category.description}</p>
          </div>
        </div>
      </div>

      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
        <div className="flex flex-wrap items-center gap-2 mb-8">
          <span className="text-sm text-foreground-500 mr-2">切换分类：</span>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                cat.slug === slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        {categoryArticles.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {categoryArticles.map((article) => (
              <ArticleCard
                key={article.id}
                {...article}
                categoryName={category.name}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <p className="text-foreground-500">该分类暂无文章</p>
            <Link to="/" className="text-primary-600 hover:text-primary-700 mt-4 inline-block">返回首页</Link>
          </div>
        )}
      </div>
    </>
  );
}